import type { RRuleState } from "@/types";
import { computed, type Ref } from "vue";
import { globali18n } from "@/i18n";

const RULE_TEXT_MAP: Record<number, string> = {
  1: "templates.rruleinput.texts.day",
  7: "templates.rruleinput.texts.week",
  30: "templates.rruleinput.texts.month",
  365: "templates.rruleinput.texts.year",
};

export function useRRuleTypeString(options: Ref<RRuleState>) {
  const { t } = globali18n;

  const typeString = computed(() => {
    const { cadence, occurence } = options.value;
    const key = RULE_TEXT_MAP[cadence];
    return t(key || "", occurence);
  });

  return {
    typeString,
  };
}
